import React from 'react';
import { PropTypes } from 'prop-types';

import { CarouselThemes } from '../../../custom-cursor/consts';

const NextSlideButton = ({ styles, onClick, theme, carouselTheme }) => {
    const isDarkTheme = carouselTheme === CarouselThemes.DARK;

    const fill = isDarkTheme ? theme.colors.black : theme.colors.white;
    const stroke = isDarkTheme ? theme.colors.cyan : theme.colors.blue;

    return (
        <button aria-label="next-slide" type="button" onClick={onClick} className={styles.button}>
            <svg viewBox="0 0 40 65">
                <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
                    <g transform="translate(0.000000, 1.000000)" fill={fill} stroke={stroke} strokeWidth="2">
                        <polygon points="7.87387228 0 0 7.72029145 24.2527616 31.5004963 0 55.2802048 7.87387228 63 40 31.5004963" />
                    </g>
                </g>
            </svg>
        </button>
    );
};

NextSlideButton.propTypes = {
    styles: PropTypes.shape({
        button: PropTypes.string.isRequired,
    }).isRequired,
    onClick: PropTypes.func.isRequired,
    theme: PropTypes.shape().isRequired,
    carouselTheme: PropTypes.string,
};

NextSlideButton.defaultProps = {
    carouselTheme: CarouselThemes.LIGHT,
};

export default NextSlideButton;
